import { PureComponent, ReactNode } from "react";
import InfoCard from "../layout_reuse/InfoCard";

import "./SettingsMenu.css";
import NoteOverrideAutoSettings from "./NoteOverrideAutoSettings";
import KeyMajorMinorToggle from "./KeyMajorMinorToggle";

interface Props {}
interface State {}

export default class SettingsMenuKeyIdentification extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render(): ReactNode {
    return (
      <div className="settings-menu-wrapper">
        <InfoCard>
          <p>Adjust how Scale Identification happens</p>
        </InfoCard>
        <InfoCard>
          <KeyMajorMinorToggle />
        </InfoCard>
        <InfoCard>
          <NoteOverrideAutoSettings />
        </InfoCard>
      </div>
    );
  }
}
